

export class SimCardActiveOutput implements ISimCardActiveOutput {
    /** The auto-generated id of the sim card details master */
    sim_card_details_id!: number;
    /** The card number with 255 character limit */
    card_number!: string;
    /** The IMSI number with 255 character limit */
    imsi_number!: string;
    /** The card activation date */
    card_activation_date!: number;
    /** The card expiry date */
    card_expiry_date!: number;
    /** The GPRS last activation date */
    gprs_last_activation_date!: number;
    /** The GPRS expiry date */
    gprs_expiry_date!: number;
    /** The tariff plan with 255 character limit */
    tariff_plan!: string;
    /** The provider name with 255 character limit */
    provider_name!: string;

    constructor(data?: ISimCardActiveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sim_card_details_id = _data["sim_card_details_id"];
            this.card_number = _data["card_number"];
            this.imsi_number = _data["imsi_number"];
            this.card_activation_date = _data["card_activation_date"];
            this.card_expiry_date = _data["card_expiry_date"];
            this.gprs_last_activation_date = _data["gprs_last_activation_date"];
            this.gprs_expiry_date = _data["gprs_expiry_date"];
            this.tariff_plan = _data["tariff_plan"];
            this.provider_name = _data["provider_name"];
        }
    }

    static fromJS(data: any): SimCardActiveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SimCardActiveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sim_card_details_id"] = this.sim_card_details_id;
        data["card_number"] = this.card_number;
        data["imsi_number"] = this.imsi_number;
        data["card_activation_date"] = this.card_activation_date;
        data["card_expiry_date"] = this.card_expiry_date;
        data["gprs_last_activation_date"] = this.gprs_last_activation_date;
        data["gprs_expiry_date"] = this.gprs_expiry_date;
        data["tariff_plan"] = this.tariff_plan;
        data["provider_name"] = this.provider_name;
        return data; 
    }
}

export interface ISimCardActiveOutput {
    /** The auto-generated id of the sim card details master */
    sim_card_details_id: number;
    /** The card number with 255 character limit */
    card_number: string;
    /** The IMSI number with 255 character limit */
    imsi_number: string;
    /** The card activation date */
    card_activation_date: number;
    /** The card expiry date */
    card_expiry_date: number;
    /** The GPRS last activation date */
    gprs_last_activation_date: number;
    /** The GPRS expiry date */
    gprs_expiry_date: number;
    /** The tariff plan with 255 character limit */
    tariff_plan: string;
    /** The provider name with 255 character limit */
    provider_name: string;
}

